const SelectInterval = ({ intervals, selectedInterval, setSelectedInterval }) => {
    return (
        <select
            id='choice-select'
            className='choice-select'
            value={selectedInterval}
            onChange={(e) => setSelectedInterval(e.target.value)}
        >
            {intervals.map((interval) => (
                <option
                    key={interval}
                    value={interval}
                >
                    {interval}
                </option>
            ))}
        </select>
    );
};

export default SelectInterval;